import { render, staticRenderFns } from "./birth-datepicker.vue?vue&type=template&id=bf678836&"
import script from "./birth-datepicker.vue?vue&type=script&lang=js&"
export * from "./birth-datepicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports